<template>
  <div :class="bem()">
    <v-empty type="error" :desription="msg">
      <div class="option btn-group">
        <nx-button @click="retry" type="frame-plus">点击重试</nx-button>
        <nx-button @click="returnHome" type="frame-plus">返回首页</nx-button>
      </div>
    </v-empty>
  </div>
</template>

<script>
import create from '../create'
import { Button } from '@vivo/vos-ui'
export default create({
  name: 'page-error',
  components: {
    [Button.name]: Button
  },
  props: {
    msg: {
      type: String,
      default: '很抱歉，服务器开小差了~'
    }
  },
  methods: {
    retry() {
      location.reload()
    },
    returnHome() {
      location.href = `${this.linkBase}`
    }
  }
})
</script>

<style lang="scss" src="./index.scss" scoped></style>
